export const Links = {
  yt: "https://youtube.com/@juliacardealy",
  insta: "https://instagram.com/juliacardealy",
  tiktok: "https://tiktok.com/@juliacardealy",
  pump: "https://pump.fun/6S4hFLa6JzbsmY8wJEuCBYrLZZAZxZ1VbvF7W8iupump",
  telegram: "https://t.me/juliascoin",
  x: "https://x.com/JuliaCoinSol",
};
